/** @format **/

import { global } from '../constants';

export function isCrashReportingInstanceView(pathName: string = global.location.pathname): boolean {
  const pattern = /^\/crashreporting\/[\w]+\/errors\/[0-9]+/;

  return pattern.test(pathName);
}
